import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const DeepLinkRedirect = () => {
    const location = useLocation();

    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const target = urlParams.get('target');
        const id = urlParams.get('id');

        if (!target) {
            // No target? Redirect to homepage or fallback
            window.location.href = 'https://www.citrin-mobility.com';
            return;
        }

        let deepLink = `citrin://${target}`;
        if (id) deepLink += `?id=${id}`;

        const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
        const isAndroid = /Android/i.test(navigator.userAgent);

        // Your app store URLs
        const iosAppStoreURL = 'https://apps.apple.com/app/idYOUR_IOS_APP_ID'; //TODO
        const androidPlayStoreURL = 'https://play.google.com/store/apps/details?id=com.citrin';

        if (isIOS || isAndroid) {
            // Try open the app
            window.location.href = deepLink;

            // After 2 seconds, redirect to the appropriate store (app not installed)
            setTimeout(() => {
                if (isIOS) {
                    window.location.href = iosAppStoreURL;
                } else if (isAndroid) {
                    window.location.href = androidPlayStoreURL;
                }
            }, 2000);
        } else {
            // Desktop fallback - redirect to homepage or download info
            window.location.href = 'https://www.citrin-mobility.com';
        }
    }, [location]);

    return (
        <div style={{ textAlign: 'center', marginTop: 40 }}>
            <p>Redirection en cours...</p>
        </div>
    );
};

export default DeepLinkRedirect;
